module.exports = __webpack_public_path__ + "media/images/apple-touch-icons/apple-touch-icon-152x152-b5c104662b0923637c5191dd9b7c7000.png";